<template>
    <div v-if="onDesktop">
        <div>
            <VDropdown
                :prevent-overflow="false"
                :shown="showDropdown"
                :overflow-padding="60"
                auto-boundary-max-size
                :placement="placement"
                :key="closeDropdown"
            >
                <slot />
                <template #popper>
                    <InboxPopperDropdown
                        :sendBotMessage="sendBotMessage"
                        :dataTree="dataTrees"
                        :isHeading="isHeading"
                        :headingText="headingText"
                        :subHeadingText="subHeadingText"
                        :isSearchAble="isSearchAble"
                        :isMultiple="isMultiple"
                        :isSubSearch="isSubSearch"
                        :singleDataTree="singleDataTrees"
                        :type="type"
                        @handleClick="handleClickMethod"
                        @SearchTag="SearchTag"
                    ></InboxPopperDropdown>
                </template>
            </VDropdown>
        </div>
    </div>
    <div v-else>
        <div @click="openMenu" type="button" v-click-outside="() => hideDropdown()" :class="classes">
            <slot />
        </div>
        <transition name="drilldown" appear>
            <div class="drilldown" :class="[active ? 'active' : '']" v-show="active">
                <DrilldownList :classes="active ? 'active' : ''" :dataTree="dataTrees"></DrilldownList>
            </div>
        </transition>
    </div>
</template>

<script setup>
import InboxPopperDropdown from "@/components/multidropdown/InboxPopperDropdown.vue";
import DrilldownList from "../multidropdown/DrillDownList.vue";
import { computed, ref, inject, watch } from "vue";
import { findParentPath } from "@/composables/globals";
const emit = defineEmits(["subNavClassList", "clickList", "SearchTag"]);
const props = defineProps({
    dataTrees: {
        type: Array,
        required: false,
    },
    isSearchAble: {
        type: Boolean,
        required: false,
        default: false,
    },
    classes: {
        type: String,
    },
    dropdownHover: {
        type: Boolean,
        default: false,
    },
    headingText: {
        type: String,
        default: "",
    },
    subHeadingText: {
        type: String,
        default: "",
    },
    isHeading: {
        type: Boolean,
        default: false,
    },
    onDiary: {
        type: Boolean,
        default: false,
    },
    OnBot: {
        type: Boolean,
        default: false,
    },
    placement: {
        type: String,
        default: "",
    },
    isMultiple: {
        type: Boolean,
        default: true,
    },
    singleDataTrees: {
        type: Array,
        required: false,
    },
    showPopper: {
        type: Boolean,
        default: false,
    },
    levelsItem: {
        type: String,
        default: "",
    },
    onBotError: {
        type: Boolean,
    },
    type: {
        type: String,
        default: "",
        required: false,
    },
    isSubSearch: {
        type: Boolean,
    },
    sendBotMessage: {
        type: Function,
        default: () => null,
    },
});

// [todo] [todooooo]: not sure what this inject is doing but apparently it is not provided. removing it for now.
// const levelsTrigger = inject('trigerLevels');
const levelsTrigger = false;

// console.log(props.singleDataTrees,'check_tag')
const active = ref(false);
const showDropdown = ref(props.showPopper);
const closeDropdown = ref(1);
const openMenu = () => {
    active.value = !active.value;
};
const onDesktop = computed(() => {
    return window.innerWidth > 768;
});
const hideDropdown = () => {
    active.value = false;
};
const triggerSelectText = ref("Select Trigger");

const handleClickMethod = (value) => {
    emit("clickList", value);
    showDropdown.value = false;
    closeDropdown.value++;
};
const handleSubNavClickMethod = (value) => {
    // console.log('subnavclass list');
    emit("subNavClassList", value);
};

const pathToItemClickMethod = (value) => {
    console.log(value.length, "pathToItemClickMethod length");
    if (value.length > 0) {
        let js_array = value;
        triggerSelectText.value = js_array.join(" / ");
        errorCheck.value = false;
        console.log(value, "pathToItemClickMethod");
    }
};

const SearchTag = (v) => {
    emit("SearchTag", v);
};

const errorCheck = ref(true);

watch(
    props.dataTrees,
    (newValue) => {
        // console.log(newValue, 'a find poath');
        // console.log(levelsTrigger, 'a find poath check levels');
        if (
            newValue &&
            newValue[0].levels &&
            levelsTrigger.levelsTrigger &&
            levelsTrigger.levelsTrigger !== "level_null_null_null"
        ) {
            errorCheck.value = false;
            const foundedPath = findParentPath(newValue, levelsTrigger.levelsTrigger);
            let js_array = foundedPath;
            triggerSelectText.value = js_array.join(" / ");
            console.log(foundedPath, "pathToItemClickMethod 1");
        } else {
            triggerSelectText.value = "select trigger";
        }
    },
    {
        deep: true,
        immediate: true,
    },
);
</script>

<style scoped></style>
